import React, { PureComponent } from "react"
import ReactMarkdown from "react-markdown"
import enhanceWithClickOutside from "react-click-outside"

import customRendererLink from "../../utils/custom-link-renderer"
import FormErrorMessage from "../form-error-message/form-error-message"
import "./text-area.scss"

class TextArea extends PureComponent {
  constructor() {
    super()
    this.state = {
      editing: false
    }
    this.textAreaRef = React.createRef()
  }
  componentDidMount() {
    if (this.props.focusOnMount) {
      this.textAreaRef.current.focus()
    }
  }

  // updateValue = (e) => {
  //   this.props.updateValue({
  //     value: e.target.value,
  //     forLabel: this.props.forLabel,
  //   });
  // };
  updateValue = (e) => {
    if (!this.state.editing) {
      // Set editing state to true if it's not already true
      this.setState({
        editing: true
      })
    }

    this.props.updateValue({
      value: e.target.value,
      forLabel: this.props.forLabel
    })
  }
  toggleEditing = () => {
    this.setState(
      {
        editing: !this.state.editing
      },
      () => this.textAreaRef.current.focus()
    )
  }

  handleClickOutside = (e) => {
    this.setState({
      editing: false
    })
  }

  onFocus = () => {
    if (this.props.onFocus) {
      this.props.onFocus()
    }
  }

  onBlur = () => {
    if (this.props.onBlur) {
      this.props.onBlur()
    }
  }

  keyDownHandler = (e) => {
    if (e.keyCode === 13) {
      if (this.props.enterToSend && !this.props.enterToSendLoading) {
        e.preventDefault()
        this.props.enterToSendFunction()
      }
    }
  }

  render() {
    const {
      value,
      placeholder,
      isValid,
      validationErrorMsg,
      hideInitEdit,
      isEditable,
      maxLength,
      updateValue,
      minWords,
      showWordCounter,
      showPreFilledOption,
      preFilledContent
    } = this.props
    console.log(this.props)
    const { editing } = this.state
    return (
      <div className="text-area">
        <FormErrorMessage
          isValid={isValid}
          validationErrorMsg={validationErrorMsg}
        />
        <div className="text-area__inner">
          {!hideInitEdit || editing || (hideInitEdit && !value) ? (
            <textarea
              ref={this.textAreaRef}
              onKeyDown={this.keyDownHandler}
              maxLength={maxLength ? maxLength : 4000}
              value={value ? value.replace(/<br \/>/g, "\n") : ""}
              onChange={this.updateValue}
              placeholder={placeholder}
              onFocus={this.onFocus}
              onBlur={this.onBlur}
            />
          ) : (
            <div className="text-area__static">
              <div className="text-area__static__value">
                <ReactMarkdown
                  source={value}
                  escapeHtml={false}
                  renderers={customRendererLink}
                />
              </div>
              {isEditable && (
                <div className="text-area__static__edit">
                  <button onClick={this.toggleEditing}>Edit</button>
                </div>
              )}
            </div>
          )}
        </div>

        {(!hideInitEdit || editing) && (
          <div
            className={
              value.split(" ").length >= minWords
                ? `word-count-green`
                : `word-count`
            }
          >
            {showPreFilledOption && (
              <button
                onClick={() => {
                  updateValue({
                    value: preFilledContent,
                    forLabel: this.props.forLabel
                  })
                }}
              >
                I’ll fill this out later
              </button>
            )}
            {showWordCounter && (
              <h5>
                {`word count ${value.split(" ").length} (${
                  minWords || 20
                } min)`}{" "}
              </h5>
            )}
          </div>
        )}
      </div>
    )
  }
}

TextArea.defaultProps = {
  enterToSend: false,
  enterToSendLoading: false,
  focusOnMount: false
}

export default enhanceWithClickOutside(TextArea)
